export default "/assets/images/slide-mini-sm.jpg?197893e35051cf365bf0215b7a845fd9";